import { SetProfileAction, SET_PROFILE, SIGN_OUT } from './authenticationActions.types';
import { Dispatch } from 'redux';
import { QueryClient } from 'react-query';
import { api } from '../../../utils/api/api';
import { User, UserDIR, UserENT, UserPUB } from '../../../types/models/user/user.types';
import { removeCookie } from '../../../utils/helpers/cookies/removeCookie';
import { Commercial } from '../../../types/api/endpoints/commercial/commercial.types';

export const setProfile =
  (profile: User | UserPUB | UserENT | UserDIR | Commercial) => (dispatch: Dispatch) => {
    dispatch<SetProfileAction>({
      type: SET_PROFILE,
      profile,
    });
  };

export const signOut = (queryClient?: QueryClient) => async (dispatch: Dispatch) => {
  removeCookie('token');
  if (queryClient) {
    queryClient.removeQueries();
  }
  Object.keys(api.headers).forEach((key) => api.deleteHeader(key));
  dispatch<any>({
    type: SIGN_OUT,
  });
};
